export function isEqualObject (firstObject, secondObject) {
  return firstObject === secondObject || JSON.stringify(firstObject) === JSON.stringify(secondObject)
}
